import io from 'socket.io-client';

const socket = io('https://mylivechatserver.herokuapp.com');
// const socket = io('http://localhost:3001');

export default socket;